import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { ReducerManager } from "./";

export default ({ preloadedState = undefined, middleware = [] }) =>
	configureStore({
		reducer: ReducerManager.reduce,
		preloadedState,
		middleware: [...getDefaultMiddleware(), ...middleware],
	});
